import { getCustomWindowObject } from '@as-react/common-utils';
import { createBrowserHistory, createMemoryHistory } from 'history';
export const getAemConfigurationFromBrowserContext = () => getCustomWindowObject('SITE.Config');
export const generateHistoryObject = () => typeof window === 'undefined' ? createMemoryHistory() : createBrowserHistory();
